/**
 * Turns the yellow CTA red where the action answers an error: a yellow button on a
 * red message read as a second, milder message (#55819).
 *
 * Scoped below #root on purpose: App.css paints `#root .bg-save-button` yellow, and an
 * id outweighs any number of classes.
 */
export const dangerFillSx = {
    "#root &.MuiButton-root.bg-save-button": {
        backgroundColor: "var(--an-rose-500)",
        color: "#fff",
    },
    "#root &.MuiButton-root.bg-save-button:hover": {
        backgroundColor: "#A33D5A",
    },
};
